import { render, staticRenderFns } from "./view.vue?vue&type=template&id=b3382970&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/scss/_main.scss?vue&type=style&index=0&id=b3382970&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3382970",
  null
  
)

export default component.exports